export  enum SizePerPageEnum {
    CINCO = '5',
    DEZ = '10',
    CINQUENTA = '50',
    CEM = '100',
}
export default SizePerPageEnum;

